<template>
    <nav class="navbar">
      <div class="logo">
        <img src="@/assets/logo.jpeg" alt="Logo" />
        <span><router-link to="/" class="navbar-item">APRAMEYA</router-link></span>
      </div>
      <div class="nav-links">
        <router-link to="/team" class="navbar-item">Team</router-link>
        <router-link to="/events" class="navbar-item">Events</router-link>
        <router-link to="/gallery" class="navbar-item">Gallery</router-link>
        <router-link to="/contact" class="navbar-item">Contact</router-link>
      </div>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'AppNavbar',
  };
  </script>
  
  <style scoped>
  .navbar {
    background-color: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .logo {
    display: flex;
    align-items: center;
    color: #fff;
  }
  
  .logo img {
    width: 100px;
    height: 30px;
    margin-right: 10px;
  }
  
  .logo span {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .nav-links {
    display: flex;
  }
  
  .navbar-item {
    font-size: 1.3rem;
    color: rgb(0, 0, 0);
    text-decoration: none;
    margin: 0 0px;
    padding: 5px 10px;
    border-radius: 5px;
    transition: background-color 0.3s ease;
    cursor: pointer;
  }
  
  .navbar-item:hover {
    background-color: #79c3e9;
  }
  .navbar-item.active{
    background-color: #aeabab;
  }
  .page-shift{
transition: transform 0.5s ease;
  }
  @media (max-width: 600px) {
    .navbar {
      flex-direction: column;
      align-items: center;
    }

    .logo {
      margin-bottom: 10px;
    }

    .logo span {
      font-size: 1.2rem;
    }

    .nav-links {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .navbar-item {
      margin: 5px 0;
    }

    .navbar-item.active {
      background-color: #555;
    }

    .page-shift {
      transition: none; /* Disable page-shift transition for mobile */
    }
  }
  </style>
  